import { IonButton, IonDatetime, IonGrid, IonRow,} from '@ionic/react'
import dayjs from 'dayjs'
import React, { useRef } from 'react'

interface ErrorInterface  {
  status: boolean,
  message: string
  title: boolean,
  map: boolean,
  start: boolean,
  type: boolean
}

interface ComponentProps {
  error?: ErrorInterface
  length_minutes: number,
  start: string,
  handleStart: Function
  setError: React.Dispatch<React.SetStateAction<ErrorInterface>>
  slideNext: Function
  slidePrevious: Function
  cancelCreate: Function
}

const CreateDay = ({ handleStart } : ComponentProps) => {
  const datetime = useRef<null | HTMLIonDatetimeElement>(null)

  const confirm = () => {
    datetime.current?.confirm()

    if(datetime.current && datetime.current.value) {
      handleStart(dayjs(datetime.current?.value as string).format('YYYY-MM-DD HH:mm'))
    }
  } 

  return (
    <IonGrid>
        <IonRow class="justify-center my-4">
          <IonDatetime 
            mode="ios"
            color="teal"
            ref={datetime}
            multiple={false}
            firstDayOfWeek={1}
            presentation="date"/> 
        </IonRow>
        <IonRow className="my-4">
          <IonButton 
            class="fullWidth m-2" 
            onClick={() => {
              confirm()
          }}>
          Välj dag 
          </IonButton>
        </IonRow>
  </IonGrid>

  )
}
export default CreateDay